import { Controller } from "@hotwired/stimulus";
import Sortable from 'sortablejs';

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".handle",
      sort: true,
      onEnd: this.end.bind(this)
    });
  }

  end(event) {
    const items = this.element.querySelectorAll('form .js-option');
    for (let index = 0; index < items.length; index++) {
      const item = items[index];

      const positionElement = item.querySelector('.js-position');
      positionElement.setAttribute('value', index);
    }
  }
}
